// About Page JavaScript

import { initMarble } from './marble.js';

// Marble animation（イベントFVと共通実装。Aboutは線なし・ライトグレー塗り）
initMarble('about-canvas', {
  fillColor: '#F8F9FB',
  strokeEnabled: false,
});
